<script>
import { mapState } from 'vuex'

export default {
  name: "ModalAuth",
  data(){
    return {
      openWin: false
    }
  },
  computed:{
    smartSales(){
      let result = []
      if(this.modalSales){
        for (var i = 0; i < this.modalSales.length; i++){
          let item = {...this.modalSales[i]}
          item.sales_begin = moment(item.sales_begin).format("DD.MM.YYYY")
          item.sales_end = moment(item.sales_end).format("DD.MM.YYYY")
          result.push(item)
        }
      }

      return result
    },
    ...mapState(['modalSales'])
  },
  methods:{
    openMobileItem(currentEl){

      $('.modal-sales-element.active').css("height", "calc(6.097rem - 0.581rem * 2)")
      if (!currentEl.hasClass('active')){
        let newHeight = $(".modal-sales-element-height").height()
        $(currentEl).css("height", newHeight)

      }
    },
    addClassElement(event){

      let currentEl = $(event.currentTarget);
      if(window.innerWidth < 700){
        this.openMobileItem(currentEl)
      }
      if(currentEl.hasClass('active')){
        $('.modal-sales-element.active').removeClass('active')
        $('.modal-sales-list').removeClass('opacity')
      }else{
        $('.modal-sales-element.active').removeClass('active')
        $('.modal-sales-list').addClass('opacity')
        currentEl.addClass('active')
      }


    }
  },
  created(){

  }
}
</script>

<template>
  <div class="modal-sales-block flex flex-xy-center">
    <div class="modal-sales left">
      <span class="modal-sales-title left">Аренда недвижимости</span>
      <span class="modal-sales-list left">
        <span class="modal-sales-element left" v-for="item in smartSales" @click="addClassElement($event)">
          <div class="modal-sales-element-height left">
            <span class="modal-sales-element-name left">{{item.partner}}</span>
            <span class="modal-sales-element-money right">{{item.sum.toLocaleString() }}
              <span class="money-ruble">₽</span>
            </span>
            <span class="modal-sales-element-date left flex flex-xy-center">{{item.sales_begin}} - {{item.sales_end}}</span>
            <span class="modal-sales-element-contract left">Договор: <strong>{{item.contract}}</strong>  </span>
            <span class="modal-sales-element-sales-number left">Номер операции: <strong>{{item.sales_number}}</strong></span>
          </div>
        </span>
      </span>
    </div>
  </div>
</template>

<style scoped>

</style>